import { ValueObject } from '@nx-smartmonkey/shared/domain';
import { ProjectPlannerValueField } from './ProjectPlannerEntityField';
import {
  ProjectPlannerStopFieldsType,
  ProjectPlannerStopSpecificFieldsType,
  ProjectPlannerTaskFieldsType,
  ProjectPlannerTaskSpecificFieldsType,
  ProjectPlannerVehicleFieldsType,
  ProjectPlannerVehicleSpecificFieldsType,
} from './ProjectPlannerFields';

export interface ProjectPlannerProps {
  vehicle_fields: Array<ProjectPlannerValueField<ProjectPlannerVehicleFieldsType>>;
  stop_fields: Array<ProjectPlannerValueField<ProjectPlannerStopFieldsType>>;
  task_fields: Array<ProjectPlannerValueField<ProjectPlannerTaskFieldsType>>;
}

export class ProjectPlanner extends ValueObject<ProjectPlannerProps> {
  get vehicle_fields() {
    return this.props.vehicle_fields;
  }

  set vehicle_fields(vehicle_fields: Array<ProjectPlannerValueField<ProjectPlannerVehicleFieldsType>>) {
    this.props.vehicle_fields = this.removeDuplicates(vehicle_fields);
  }

  get stop_fields() {
    return this.props.stop_fields;
  }

  set stop_fields(stop_fields: Array<ProjectPlannerValueField<ProjectPlannerStopFieldsType>>) {
    this.props.stop_fields = this.removeDuplicates(stop_fields);
  }

  get task_fields() {
    return this.props.task_fields;
  }

  set task_fields(task_fields: Array<ProjectPlannerValueField<ProjectPlannerTaskFieldsType>>) {
    this.props.task_fields = this.removeDuplicates(task_fields);
  }

  stopFieldsHasSpecificField(fieldId: ProjectPlannerStopSpecificFieldsType) {
    return Boolean(this.props.stop_fields.find((field) => field.id === fieldId && !field.is_custom_field));
  }

  stopCustomFields() {
    return this.props.stop_fields.filter((field) => field.is_custom_field);
  }

  stopHasCustomField(fieldId: string) {
    return Boolean(this.stopCustomFields().find((field) => field.id === fieldId && field.is_custom_field));
  }

  vehicleFieldsHasSpecificField(fieldId: ProjectPlannerVehicleSpecificFieldsType) {
    return Boolean(this.props.vehicle_fields.find((field) => field.id === fieldId && !field.is_custom_field));
  }

  vehicleCustomFields() {
    return this.props.vehicle_fields.filter((field) => field.is_custom_field);
  }

  vehicleHasCustomField(fieldId: string) {
    return Boolean(this.vehicleCustomFields().find((field) => field.id === fieldId && field.is_custom_field));
  }

  taskFieldsHasSpecificField(fieldId: ProjectPlannerTaskSpecificFieldsType) {
    return Boolean(this.props.task_fields.find((field) => field.id === fieldId && !field.is_custom_field));
  }

  taskCustomFields() {
    return this.props.task_fields.filter((field) => field.is_custom_field);
  }

  taskHasCustomField(fieldId: string) {
    return Boolean(this.taskCustomFields().find((field) => field.id === fieldId && field.is_custom_field));
  }

  private constructor(props: ProjectPlannerProps) {
    super(props);
  }

  static create(props: ProjectPlannerProps): ProjectPlanner {
    return new ProjectPlanner(props);
  }

  private removeDuplicates(array: Array<ProjectPlannerValueField<any>>): Array<ProjectPlannerValueField<any>> {
    return array.filter((obj, index, self) => index === self.findIndex((t) => t.id === obj.id));
  }
}
